<template>
  <div>
    <download-excel :data="usersFilledAssessments">Download Data</download-excel>
  </div>
</template>

<script>
import firebase from "firebase/app";
import { store } from "../store";
import moment from "moment";


export default {
  name: "AdminExcelAssessments",
  created() {
    this.refassessments.onSnapshot(querySnapshot => {
      console.log("onsnapshot fired");
      this.usersFilledAssessments = [];
      var lp = 0;
      var i=0;

      querySnapshot.forEach(doc => {
        lp++;
        i=0;
        this.usersFilledAssessments.push({
          lp: lp,
          user: doc.data().user,
          sumofpoints: doc.data().sumofpoints,
          score: doc.data().assessmentscore,
          createdAt: doc.data().createdAt?moment(doc.data().createdAt.seconds).format('LLL'):'',
          points01: doc.data().pointsarr[0]?doc.data().pointsarr[0].points:0,
          points02: doc.data().pointsarr[1]?doc.data().pointsarr[1].points:0,
          points03: doc.data().pointsarr[2]?doc.data().pointsarr[2].points:0,
          points04: doc.data().pointsarr[3]?doc.data().pointsarr[3].points:0,
          points05: doc.data().pointsarr[4]?doc.data().pointsarr[4].points:0,
          points06: doc.data().pointsarr[5]?doc.data().pointsarr[5].points:0,
          points07: doc.data().pointsarr[6]?doc.data().pointsarr[6].points:0,
          points08: doc.data().pointsarr[7]?doc.data().pointsarr[7].points:0,
          points09: doc.data().pointsarr[8]?doc.data().pointsarr[8].points:0,
          points10: doc.data().pointsarr[9]?doc.data().pointsarr[9].points:0,

          companyName: (doc.data().postAssessmentForm&&doc.data().postAssessmentForm[i])?doc.data().postAssessmentForm[i++].value:'',
          established: (doc.data().postAssessmentForm&&doc.data().postAssessmentForm[i])?doc.data().postAssessmentForm[i++].value:'',
          role: (doc.data().postAssessmentForm&&doc.data().postAssessmentForm[i])?doc.data().postAssessmentForm[i++].value:'',
          industry: (doc.data().postAssessmentForm&&doc.data().postAssessmentForm[i])?doc.data().postAssessmentForm[i++].value:'',
          employees: (doc.data().postAssessmentForm&&doc.data().postAssessmentForm[i])?doc.data().postAssessmentForm[i++].value:'',
          signUpCause: (doc.data().postAssessmentForm&&doc.data().postAssessmentForm[i])?doc.data().postAssessmentForm[i++].value:'',
          revenue: (doc.data().postAssessmentForm&&doc.data().postAssessmentForm[i])?doc.data().postAssessmentForm[i++].value:'',
          targetRevenue: (doc.data().postAssessmentForm&&doc.data().postAssessmentForm[i])?doc.data().postAssessmentForm[i++].value:'',
          clients: (doc.data().postAssessmentForm&&doc.data().postAssessmentForm[i])?doc.data().postAssessmentForm[i++].value:'',
          targetClients: (doc.data().postAssessmentForm&&doc.data().postAssessmentForm[i])?doc.data().postAssessmentForm[i++].value:'',
          topChallenges: (doc.data().postAssessmentForm&&doc.data().postAssessmentForm[i])?doc.data().postAssessmentForm[i++].value:'',
        });
      });
    }); //onSnapshot
  },
  data() {
    return {
      usersFilledAssessments: [],
      refassessments: firebase.firestore().collection("usersFilledAssessments")
    };
  },
  methods: {}
};
</script>
